import { baseTemplateParams } from '../shared/baseParams.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: 'transparent',
  logoUrl: '',
  heroImgUrl: '',
  heroImageLinkUrl: '',
  preheaderText: 'This text will appear next to your subject line in the inbox.',
  subject: 'This is the email subject',
  selectedTemplate: 'default',
  shellTemplateKey: 'default'
}

export default defaultTemplateParams
